import React from "react";

/**
 * Brand logo for MakeYourBrand.IN
 * - `variant="full"` shows the wordmark next to the icon
 * - `variant="icon"` shows only the icon
 * - `size` controls the icon height (rem)
 */
export const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_ai-agency-platform-3/artifacts/nrx9ad9i_MakeYourBrand.IN%20Logo.png";

export default function Logo({
  variant = "full",
  size = "h-9",
  className = "",
  hideText = false,
}) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_SRC}
        alt="MakeYourBrand.IN logo"
        className={`${size} w-auto object-contain drop-shadow-[0_0_18px_rgba(99,102,241,0.45)] select-none`}
        draggable="false"
      />
      {variant === "full" && !hideText && (
        <span className="font-heading font-black text-lg tracking-tight whitespace-nowrap">
          MakeYour<span className="brand-gradient-text">Brand.IN</span>
        </span>
      )}
    </div>
  );
}
